(() => {
  if (customElements.get('featured-collections-tabs')) {
    return;
  }

  class FeaturedCollectionsTabs extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tablist || this.tabs.length === 0 || this.tabs.length !== this.panels.length) {
        return;
      }

      this.tablist.addEventListener('click', this.handleClick);
      this.tablist.addEventListener('keydown', this.handleKeydown);

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    disconnectedCallback() {
      if (!this.tablist) {
        return;
      }

      this.tablist.removeEventListener('click', this.handleClick);
      this.tablist.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    get activeIndex() {
      const index = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

      return index === -1 ? 0 : index;
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');

      if (!tab) {
        return;
      }

      this.activate(this.tabs.indexOf(tab), false);
    }

    handleKeydown(event) {
      const count = this.tabs.length;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this.activate((this.activeIndex - 1 + count) % count, true);
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.activate((this.activeIndex + 1) % count, true);
          break;
        case 'Home':
          event.preventDefault();
          this.activate(0, true);
          break;
        case 'End':
          event.preventDefault();
          this.activate(count - 1, true);
          break;
      }
    }

    handleBlockSelect(event) {
      const panel = event.target.closest('[role="tabpanel"]');
      const index = this.panels.indexOf(panel);

      if (index !== -1) {
        this.activate(index, false);
      }
    }

    activate(index, moveFocus) {
      if (index < 0 || index >= this.tabs.length) {
        return;
      }

      this.tabs.forEach((tab, position) => {
        const selected = position === index;

        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        this.panels[position].toggleAttribute('hidden', !selected);
      });

      // The slider inside a panel was never measurable while the panel was hidden.
      const slider = this.panels[index].querySelector('collection-slider');

      if (slider && typeof slider.refresh === 'function') {
        slider.refresh();
      }

      this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });

      if (moveFocus) {
        this.tabs[index].focus();
      }
    }
  }

  window.FeaturedCollectionsTabs = FeaturedCollectionsTabs;
  customElements.define('featured-collections-tabs', FeaturedCollectionsTabs);
})();
